<template>
  <div>
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      Образование
    </div>

    <div>
      <template v-for="(education, i) in localValue">
        <c-item
          :key="education.unique"
          :value="education"
          :preview="preview"
          :editable="editable"
          :error="error && error.items && error.items[i]"
          :can-remove="true"
          class="item"
          @remove="removeEducation(education)"
        />
      </template>
    </div>

    <div class="add-education">
      <c-button
        :icon="{ icon: 'plus', color: 'primary' }"
        label="Добавить образование"
        :disabled="preview || !editable || hasEmpty"
        size="small"
        @click="addEducation"
      />
    </div>

    <error-feedback v-if="error && error.common" :text="error && error.common" />
  </div>
</template>

<script>
import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";
import CItem from "./Item";

import { getUnique } from "@/utils/number/unique";
import { isEmptyEducation } from "./utils";

export default {
  components: { CButton, CItem, ErrorFeedback },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: [],
    };
  },

  computed: {
    hasEmpty() {
      return this.localValue.some(isEmptyEducation);
    },
  },

  watch: {
    localValue: {
      handler() {
        this.updateValue();
      },
      deep: true,
    },
    value(v) {
      this.setData(v);
    },
   
  },

  created() {
    //console.log(this.field)
    if (this.value) this.setData(this.value);
    if (!this.localValue.length && this.field.required) this.addEducation();
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const newItems = (value.value && value.value.educations) || [];
      const currentItems = this.localValue.map((item) => {
        const { unique, ...fields } = item;
        return fields;
      });

      if (JSON.stringify(newItems) !== JSON.stringify(currentItems)) {
        this.localValue = newItems.map((item) => ({ unique: getUnique(), ...item }));
      }

      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      const newValue = this.localValue.map((item) => {
        const { unique, ...fields } = item;
        return fields;
      });
      this.$emit("input", {
        value: {
          educations: newValue,
        },
      });
      if (this.inited) {
        this.$emit("change");
      }
    },
    addEducation() {
      const model = {
        unique: getUnique(),
        institution: "",
        specialization: "",
        from: "",
        to: "",
      };
      this.localValue.push(model);
    },
    removeEducation(education) {
      this.localValue = this.localValue.filter((i) => i !== education);
    },
  },
};
</script>

<style lang="scss" scoped>
.add-education {
  margin-top: 25px;
}
.item {
  &:not(:first-child) {
    margin-top: 25px;
  }
}
</style>
